import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

export const Title = ({ children }: PropsWithChildren) => (
    <TruncatedTextWithTooltip
        fontVariant="subtitle1"
        color={colorsPalettes.carbon[500]}
        minWidth={0}
        data-automation="alert-title"
    >
        {children}
    </TruncatedTextWithTooltip>
);
